import { Button } from '@mui/material'
import AlphabetGrid from '../AlphabetGrid';
import { useState } from 'react';
import { randomStrings } from '../constData'
import CustomButton from '../CustomButton';

const KeylessCipherExercise = () => {
    const [showAnsButton, setShowAnsButton] = useState(false);
    const [showCorrectAns, setShowCorrectAns] = useState(false);
    const [isKeyValid, setIsKeyValid] = useState(true)

    const generateString = () => {
        var index = Math.floor(Math.random() * (29 - 0 + 1) + 0);
        return randomStrings[index];
    }

    function handleStringGenerate() {
        var string = generateString();
        document.getElementById("plaintext").value = string.replace(/\s/g, "");
        console.log("We Generated a String! : ", string);
    }

    function handleKeyGenerate() {
        var key = Math.floor(Math.random() * (6 - 1 + 2) + 2);
        document.getElementById("key").value = key;
        console.log("We Generated a Key! : ", key);
    }



    const encrypt = async (text, s) => {
        let fence = [];
        for (let i = 0; i < s; i++) {
            fence.push([]);
        }

        let rail = 0;
        let direction = 1;

        for (let i = 0; i < text.length; i++) {
            fence[rail].push([text[i], i, rail]);
            rail += direction;
            if (rail === 0 || rail === s - 1) {
                direction = -direction;
            }
        }

        let result = '';
        for (let rail of fence) {
            let row = []
            for (let char of rail) {
                row.push(char[0])
                result += char[0]
            }
        }

        return result;

    }

    function handleSubmit(e) {
        // Prevent the browser from reloading the page
        e.preventDefault();

        // Read the form data
        const form = e.target;
        const formData = new FormData(form);

        // You can pass formData as a fetch body directly:
        // fetch('/some-api', { method: form.method, body: formData });

        // Or you can work with it as a plain object:
        const formJson = Object.fromEntries(formData.entries());
        console.log(formJson);

        setShowCorrectAns(false);

        var k = parseInt(formData.get("key"));
        var pt = formData.get("plaintext").toUpperCase();

        setShowCorrectAns(false);

        if (k < 2 || k > pt.length ) {
            setIsKeyValid(false);
        } else {
            setIsKeyValid(true);
            var res = encrypt(pt, k).then((val1) => {
                var val2 = formData.get("answer").toUpperCase();
                console.log(val1)
                console.log(val2)
                document.getElementById("correctAns").innerHTML = val1;

                if (val1 === val2) {
                    document.getElementById("result").innerHTML = "Correct Answer!";
                    document.getElementById("result").style.color = "green";
                    console.log("Correct Answer!");
                    setShowAnsButton(false);
                    setShowCorrectAns(false);
                } else {
                    document.getElementById("result").innerHTML = "Wrong Answer!";
                    document.getElementById("result").style.color = "red";
                    console.log("Wrong Answer!");
                    setShowAnsButton(true);
                }

            })
        }
    }

    function showAns() {
        setShowCorrectAns(true);
    }

    return (
        <>
            <form method="post" onSubmit={handleSubmit}>
                <label>
                    Plain Text (only alphabets, without spaces):
                    <input pattern="[a-zA-Z]+" style={{ textTransform: "uppercase" }} required={true} name="plaintext" id='plaintext' />
                    <CustomButton onClick={handleStringGenerate} isSmall={true}>Generate</CustomButton>
                    {/* <Button variant="contained" type='button' size='small' onClick={handleStringGenerate} style={{marginLeft:20}}>Generate</Button> */}
                </label>
                <br />
                <br />
                <label>
                    Key/Rails:
                    <input name="key" required={true} type="number" id='key' />
                    <CustomButton onClick={handleKeyGenerate} isSmall={true}>Generate</CustomButton>
                    <p style={{ display: isKeyValid ? "none" : "inline", color: "red", fontSize: 15 }}>Invalid Key! Key should be greater than 1 and less than or equal to plaintext</p>
                    {/* <Button variant="contained" type='button' size='small' onClick={handleKeyGenerate} style={{ marginLeft: 20 }}>Generate</Button> */}
                </label>
                <br />
                <br />

                <label>
                    Your Answer:
                    <input pattern="[a-zA-Z]+" required={true} style={{ textTransform: "uppercase" }} name="answer" id='answer' />
                </label>
                <br />
                <br />

                <CustomButton type="submit" isSmall={true} beforeHover={"#54B435"} afterHover={"#379237"}>Check Answer</CustomButton>
                {/* <Button variant="contained" type='submit' size='medium' style={{ backgroundColor: "green" }}>Check Answer</Button> */}

            </form>
            <br />
            <p id='result' style={{ fontSize: 20, fontWeight: "bold", display: "inline" }}></p>
            <CustomButton onClick={showAns} display={showAnsButton ? "inline" : "none"} isSmall={true} beforeHover={"#FF204E"} afterHover={"#E72929"}>Show Answer</CustomButton>
            {/* <Button variant="contained" type='button' size='small' style={{ display: showAnsButton ? "inline" : "none", backgroundColor: "red" }} onClick={showAns}> Show Answer </Button> */}
            <p id='correctAns' style={{ fontSize: 18, fontWeight: "bold", display: showCorrectAns ? "block" : "none" }}></p>
        </>
    )
}

export default KeylessCipherExercise